import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface GalleryItem {
  src: string;
  category: string;
  label: string;
}
export function GalleryPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [activeFilter, setActiveFilter] = useState('All');
  const filters = ['All', 'Roofing', 'Gutters', 'Siding', 'Windows', 'Painting'];
  const gallery: GalleryItem[] = [{
    src: 'https://images.unsplash.com/photo-1558618666-fcd25c85f82e?w=600&q=80',
    category: 'Roofing',
    label: 'Roof Replacement — Harrison Township'
  }, {
    src: 'https://images.unsplash.com/photo-1480074568708-e7b720bb3f09?w=600&q=80',
    category: 'Siding',
    label: 'Vinyl Siding — Clinton Township'
  }, {
    src: 'https://images.unsplash.com/photo-1605276374104-dee2a0ed3cd6?w=600&q=80',
    category: 'Roofing',
    label: 'Architectural Shingles — Port Huron'
  }, {
    src: 'https://images.unsplash.com/photo-1583608205776-bfd35f0d9f83?w=600&q=80',
    category: 'Windows',
    label: 'Window Replacement — Sterling Heights'
  }, {
    src: 'https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=600&q=80',
    category: 'Siding',
    label: 'Fiber Cement Siding — Macomb'
  }, {
    src: 'https://images.unsplash.com/photo-1572120360610-d971b9d7767c?w=600&q=80',
    category: 'Windows',
    label: 'Bay Window Install — Troy'
  }, {
    src: 'https://images.unsplash.com/photo-1449844908441-8829872d2607?w=600&q=80',
    category: 'Roofing',
    label: 'Full Tear-Off — Marysville'
  }, {
    src: 'https://images.unsplash.com/photo-1632759145351-1d592919f522?w=600&q=80',
    category: 'Roofing',
    label: 'Storm Damage Repair — Chesterfield'
  }, {
    src: 'https://images.unsplash.com/photo-1585129777188-94600bc7b4b3?w=600&q=80',
    category: 'Gutters',
    label: 'Seamless Gutters — New Baltimore'
  }, {
    src: 'https://images.unsplash.com/photo-1562259949-e8e7689d7828?w=600&q=80',
    category: 'Painting',
    label: 'Exterior Painting — Roseville'
  }, {
    src: 'https://images.unsplash.com/photo-1523217582562-09d0def993a6?w=600&q=80',
    category: 'Gutters',
    label: 'Gutter Guards — Warren'
  }, {
    src: 'https://images.unsplash.com/photo-1598228723793-52759bba239c?w=600&q=80',
    category: 'Painting',
    label: 'Full Exterior Repaint — Utica'
  }];
  const filtered = activeFilter === 'All' ? gallery : gallery.filter(item => item.category === activeFilter);
  return <div className="w-full bg-white" data-id="element-786">
      {/* Hero */}
      <section className="relative min-h-[35vh] flex items-center pt-20 pb-12 overflow-hidden bg-brand-gray-dark" data-id="element-787">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full relative z-10" data-id="element-788">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-789">
            <h1 className="font-heading font-black text-4xl md:text-5xl text-white mb-4" data-id="element-790">
              Our <span className="text-brand-blue" data-id="element-791">Project Gallery</span>
            </h1>
            <p className="font-body text-xl text-gray-300 max-w-2xl" data-id="element-792">
              Browse our portfolio of completed roofing, siding, gutter, and
              exterior projects across Southeast Michigan.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Filters + Gallery */}
      <section className="py-16" data-id="element-793">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-794">
          {/* Filter Tabs */}
          <div className="flex flex-wrap gap-3 mb-12 justify-center" data-id="element-795">
            {filters.map(filter => <button key={filter} onClick={() => setActiveFilter(filter)} className={`font-body font-semibold px-6 py-2.5 rounded-lg transition-all text-sm ${activeFilter === filter ? 'bg-brand-blue text-white shadow-md' : 'bg-gray-100 text-brand-gray hover:bg-gray-200'}`} data-id="element-796">
                {filter}
              </button>)}
          </div>

          {/* Masonry Grid */}
          <div className="columns-1 sm:columns-2 lg:columns-3 gap-6 space-y-6" data-id="element-797">
            <AnimatePresence mode="popLayout" data-id="element-798">
              {filtered.map((item, index) => <motion.div key={item.src} layout initial={{
              opacity: 0,
              scale: 0.9
            }} animate={{
              opacity: 1,
              scale: 1
            }} exit={{
              opacity: 0,
              scale: 0.9
            }} transition={{
              duration: 0.4
            }} className="break-inside-avoid rounded-xl overflow-hidden shadow-md group relative" data-id="element-799">
                  <div className="brand-overlay" data-id="element-800">
                    <img src={item.src} alt={item.label} className="w-full h-auto object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-801" />
                  </div>
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/50 transition-all duration-300 flex items-end z-10" data-id="element-802">
                    <div className="p-4 translate-y-full group-hover:translate-y-0 transition-transform duration-300 w-full" data-id="element-803">
                      <span className="inline-block bg-brand-blue text-white text-xs font-body font-bold px-2 py-1 rounded mb-2" data-id="element-804">
                        {item.category}
                      </span>
                      <p className="font-body text-white font-semibold text-sm" data-id="element-805">
                        {item.label}
                      </p>
                    </div>
                  </div>
                </motion.div>)}
            </AnimatePresence>
          </div>
        </div>
      </section>
    </div>;
}